import {InitPage} from "../../index";
import * as Toastr from "toastr";

export class ElcProductionHelpRequest {
    constructor(){}

    submitStatusUpdate(e: JQuery.Event): void {
        $.ajax({
            type: "PUT",
            url:  $(e).data("path"),
            data: {
              status: $(e).val()
            }
        }).then(response => {
            if (response.status != "OK") {
                console.log(response);
                Toastr.error(response.status, "Error");
            } else {
                console.log(response);
                Toastr.success("Help request status updated", "Saved");

            }
        });
    }
}

declare global {
    interface Window {
        ElcProductionHelpRequest: ElcProductionHelpRequest;
    }
}

export function LoadPage() {
    InitPage("elc cards", () => {
        window.ElcProductionHelpRequest = new ElcProductionHelpRequest();
    });
}
